import { render, staticRenderFns } from "./OurVerbalIdentityIntroSection.vue?vue&type=template&id=7bc97d8a"
import script from "./OurVerbalIdentityIntroSection.vue?vue&type=script&lang=ts"
export * from "./OurVerbalIdentityIntroSection.vue?vue&type=script&lang=ts"
import style0 from "./OurVerbalIdentityIntroSection.vue?vue&type=style&index=0&id=7bc97d8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports